module.exports = __webpack_public_path__ + "static/media/dot_FFD600_a.d2121f2f.svg";